import clsx from 'clsx';
import type { ButtonHTMLAttributes } from 'react';

import { Icon, type IconName } from './Icon';
import styles from './IconButton.module.css';

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: IconName;
  /** Required: an icon-only control needs an accessible name. */
  label: string;
  size?: 'sm' | 'md';
  bordered?: boolean;
  active?: boolean;
}

export function IconButton({
  icon,
  label,
  size = 'md',
  bordered = false,
  active = false,
  className,
  type = 'button',
  ...rest
}: IconButtonProps) {
  return (
    <button
      type={type}
      aria-label={label}
      title={label}
      className={clsx(
        styles.base,
        styles[size],
        bordered && styles.bordered,
        active && styles.active,
        className,
      )}
      {...rest}
    >
      <Icon name={icon} size={size === 'sm' ? 15 : 17} />
    </button>
  );
}
